import { useState } from "react";
import DataTable from "../../components/common/DataTable.tsx";
import { RevivedPoliciesColumns } from "../../components/lapsedPolicy/RevivedPoliciesColumn.tsx";
import { useLapsedPolicies } from "../../redux/store/lapsedPolicies.js";
import { useEffect } from "react";
import { Pagination } from "rsuite";

const RevivedPoliciesList = () => {
  const { get_RevivedPolicyList, revivedPolicies } = useLapsedPolicies();
  const [loading, setloading] = useState(true);

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  useEffect(() => {
    get_RevivedPolicyList({ displayLength: 1000, displayStart: 0 }).finally(
      () => {
        setloading(false);
      }
    );
  }, []);


  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };

  const data = revivedPolicies.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  return (
    <div className="shadow bg-white rounded-lg p-4">
      <h4 className="font-semibold text-lg mb-2">Revived Policies</h4>

      <DataTable
        columns={RevivedPoliciesColumns}
        data={data}
        loading={loading}
      />

      <Pagination
        prev
        next
        first
        last
        ellipsis
        boundaryLinks
        maxButtons={5}
        size="sm"
        layout={["total", "-", "limit", "|", "pager", "skip"]}
        className="mt-5"
        total={revivedPolicies.length}
        limitOptions={[10, 30, 50]}
        limit={limit}
        activePage={page}
        onChangePage={setPage}
        onChangeLimit={handleChangeLimit}
      />
    </div>
  );
};

export default RevivedPoliciesList;
